"use client";

import type { ReactNode } from "react";
import { Search } from "@/components/icons";
import { RepackifyMark } from "@/components/brand/repackify-logo";
import { useSearchContextSafe } from "./SearchContext";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { IconButton } from "@/components/ui/icon-button";

interface PublicSearchTriggerProps {
  className?: string;
  placeholder?: string;
}

function OpenSearchForm({ children }: { children: ReactNode }) {
  const { openSearch } = useSearchContextSafe();
  return (
    <form action={openSearch} className="contents">
      {children}
    </form>
  );
}

export function PublicSearchTrigger({
  className,
  placeholder = "Search packaging or ask Repackify",
}: PublicSearchTriggerProps) {
  return (
    <div
      className={cn(
        "flex h-10 items-center rounded-full border border-border bg-surface px-1 transition-colors hover:border-fg-muted focus-within:ring-2 focus-within:ring-ring",
        className,
      )}
    >
      <OpenSearchForm>
        <Button type="submit" variant="field" size="default" className="min-w-0 flex-1">
          <Search />
          <span className="flex-1 truncate text-left">{placeholder}</span>
          <RepackifyMark alt="" className="h-3.5" />
        </Button>
      </OpenSearchForm>
    </div>
  );
}

export function PublicSearchIconTrigger({ className }: { className?: string }) {
  return (
    <OpenSearchForm>
      <IconButton
        type="submit"
        size="compact"
        className={cn("rounded-full text-muted-foreground", className)}
        aria-label="Search"
      >
        <Search />
      </IconButton>
    </OpenSearchForm>
  );
}
